module.exports = __webpack_public_path__ + "img/bg-image-17.e3eff99c.jpg";